import { useQuery } from "@tanstack/react-query";
import { getStudioDetails } from "entities/studios/api/getStudioDetails";

export const useModuleSelectedStudiosQuery = (studioIds: number[]) => {
  return useQuery({
    queryKey: ["moduleSelectedStudios", studioIds],
    queryFn: async () => {
      return Promise.all(
        studioIds.map(async (studioId) => {
          return getStudioDetails(studioId.toString());
        }),
      );
    },
    staleTime: 0,
  });
};
